import script from "./NewsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsCard.vue?vue&type=script&setup=true&lang=js"

import "./NewsCard.vue?vue&type=style&index=0&id=b91672fa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b91672fa"]])

export default __exports__